import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "landing-columns" }
const _hoisted_2 = { class: "collection-list" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "collection-actions" }
const _hoisted_5 = { class: "collection-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_ontos_markdown_expandable = _resolveComponent("ontos-markdown-expandable")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ontos_section = _resolveComponent("ontos-section")!
  const _component_ontos_recent_row = _resolveComponent("ontos-recent-row")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, { ref: "base" }), {
    default: _withCtx(() => [
      _createVNode(_component_ontos_page_header, {
        title: _ctx.workspace.title
      }, null, 8, ["title"]),
      (_ctx.description)
        ? (_openBlock(), _createBlock(_component_ontos_markdown_expandable, {
            key: 0,
            value: _ctx.description,
            full: "",
            class: "workspace-description text-body-1"
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ontos_section, {
          title: _ctx.$tt('collections'),
          divider: false,
          level: 2,
          dense: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row.idea.alias,
                  class: "collection-row"
                }, [
                  _createVNode(_component_router_link, {
                    class: "collection-name text-subtitle-1",
                    to: _ctx.routeTo('collection', row.idea)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.idea.pluralName), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (_openBlock(), _createElementBlock("span", {
                    key: row.countText,
                    class: "collection-count ontos-arrives text-body-2 text-medium-emphasis"
                  }, _toDisplayString(row.countText), 1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["state-bar", {'state-bar--empty': !row.segments.length}]),
                    title: row.statesText
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.segments, (segment) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: segment.key,
                        class: _normalizeClass(["ontos-arrives", _ctx.accentClass(segment.color)]),
                        style: _normalizeStyle({flexGrow: segment.count})
                      }, null, 6))
                    }), 128))
                  ], 10, _hoisted_3),
                  (_openBlock(), _createElementBlock("span", {
                    key: row.updatedText,
                    class: "collection-updated ontos-arrives text-caption text-medium-emphasis"
                  }, _toDisplayString(row.updatedText), 1)),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_btn, {
                      icon: "",
                      variant: "text",
                      size: "small",
                      title: _ctx.$tt('list'),
                      to: _ctx.routeTo('list-instances', row.idea)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("mdi-view-list", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title", "to"]),
                    (_ctx.hasKanban(row.idea))
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          icon: "",
                          variant: "text",
                          size: "small",
                          title: _ctx.$tt('kanban'),
                          to: _ctx.routeTo('kanban', row.idea)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createTextVNode("mdi-view-dashboard-outline", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["title", "to"]))
                      : _createCommentVNode("", true),
                    (_ctx.canCreateIn(row.idea))
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          icon: "",
                          variant: "text",
                          size: "small",
                          title: _ctx.$tt('instance-create', {collection: row.idea.name}),
                          onClick: ($event: any) => (_ctx.requestCreation(row.idea.alias))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode("mdi-plus", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["title", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["title"]),
        (_ctx.recent.length)
          ? (_openBlock(), _createBlock(_component_ontos_section, {
              key: 0,
              class: "ontos-arrives",
              title: _ctx.$tt('recently-changed'),
              divider: false,
              level: 2,
              dense: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recent, (item) => {
                    return (_openBlock(), _createBlock(_component_ontos_recent_row, {
                      key: `${item.idea}.${item._instance}`,
                      item: item,
                      place: _ctx.ideaName(item.idea),
                      to: {name: 'view-instance', params: {..._ctx.$route.params, idea: item.idea, instance: item._instance}}
                    }, null, 8, ["item", "place", "to"]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 16))
}